import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "./includes/Footer";
import { history } from "../helper/History";
import { Field, reduxForm } from "redux-form";
import { contactacoach, clearContactCoachMessage } from "../actions";
import $ from "jquery";
import { FormattedMessage } from "react-intl";
import ReCAPTCHA from "react-google-recaptcha";

class ContactToCoach extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],
      isSubmit: null,
      language: null,
      testType: null,

      // ✅ captcha
      recaptchaToken: null,
      recaptchaError: null,
    };

    window.scrollTo(0, 0);
    this.contactToCoachForm = this.contactToCoachForm.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
  }

  componentDidMount() {
    if (this.props.isSignedIn) {
      let testType = localStorage.getItem("testType");
      this.setState({ testType: testType });

      let language;
      if (this.props.lang === "en") language = "english";
      if (this.props.lang === "fr") language = "french";
    }
  }

  onCaptchaChange(token) {
    this.setState({ recaptchaToken: token, recaptchaError: null });
  }

  onCaptchaExpired() {
    this.setState({
      recaptchaToken: null,
      recaptchaError: "Captcha expired. Please verify again.",
    });
  }

  contactToCoachForm(values) {
    // ✅ block submit if captcha not verified
    if (!this.state.recaptchaToken) {
      this.setState({ recaptchaError: "Please verify captcha before submit." });
      return;
    }

    values["language"] = this.props.lang;

    // ✅ send captcha token to Laravel
    values["captcha_token"] = this.state.recaptchaToken;

    $("#contactus-loader").show();
    this.refs.sbmt.setAttribute("disabled", "disabled");

    this.props.contactacoach(values, this.refs.sbmt, (response) => {
      if (response === "success") {
        this.props.reset("contactUsValidation");
        $("#contactus-loader").hide();

        // reset captcha after success
        this.setState({ recaptchaToken: null, recaptchaError: null });
       

        if (localStorage.getItem("navigation") != "individual") {
          setTimeout(function () {
            window.location = "/hr";
          }, 10000);
        } else {
          setTimeout(function () {
            window.location = "/individual";
          }, 10000);
        }
      } else {
        $("#contactus-loader").hide();
        this.refs.sbmt.removeAttribute("disabled");
      }
    });
  }

  renderInput(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <input
          type={field.type}
          className="form-control"
          placeholder={field.placeholder}
          autoComplete="off"
          {...field.input}
        />
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  renderTextarea(field) {
    return (
      <div className="form-group">
        <label>{field.label}</label>
        <textarea
          type={field.type}
          className="form-control md-textarea"
          placeholder={field.placeholder}
          {...field.input}
        ></textarea>
        {field.meta.touched && field.meta.error && (
          <small className="text-danger">{field.meta.error}</small>
        )}
      </div>
    );
  }

  errorMessage() {
    const { testType } = this.state;

    if (this.props.contactCoachError !== null && this.props.contactCoachError !== "") {
      return (
        <div className="col-md-12 alert alert-danger" role="alert">
          {this.props.contactCoachError}
        </div>
      );
    }
    if (this.props.contactCoachMessage !== null && this.props.contactCoachMessage !== "") {
      return (
        <div className="col-md-12 alert alert-success" role="alert">
          {this.props.contactCoachMessage}
        </div>
      );
    }
  }

  render() {
    const { testType } = this.state;
    var redirectUrl = testType === "individual" ? "individual" : "hr";

    const firstname = (
      <FormattedMessage
        id="contact.us.name"
        defaultMessage="First name, Name *"
      />
    );
    const emailaddress = (
      <FormattedMessage
        id="contact.us.emailaddress"
        defaultMessage="Email address *"
      />
    );
    const phoneno = (
      <FormattedMessage
        id="contact.us.phoneno"
        defaultMessage="Phone Number"
      />
    );
    const yourmessage = (
      <FormattedMessage
        id="contact.us.message"
        defaultMessage="Your message *"
      />
    );

    // ✅ use env key; replace placeholder if env not set
   const RECAPTCHA_SITE_KEY_NEW = "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";
    const RECAPTCHA_SITE_KEY =
      RECAPTCHA_SITE_KEY_NEW || "6Ldn0VcsAAAAAFg2CyFl6lpg37k6XN64zROfXsgn";

    return (
      <React.Fragment>
        <section className="mb-4 pages">
          <div className="container">
            <h2 className="h1-responsive font-weight-bold text-center my-4">
              <FormattedMessage
                id="contact_coach_title"
                defaultMessage="Contact a Coach"
              />
            </h2>

            {this.props.contactCoachMessage == null ? (
              <div className="row">
                <p className="text-center w-responsive mx-auto mb-5">
                  <FormattedMessage
                    id="contact_coach_sub_title"
                    defaultMessage="Please leave your contact details and message below and you will be contacted soon."
                  />
                </p>

                <div className="row w-100">{this.errorMessage()}</div>

                <form
                  id="contact-form"
                  onSubmit={this.props.handleSubmit((e) =>
                    this.contactToCoachForm(e)
                  )}
                  className="row w-100"
                >
                  <div className="col-lg-10 col-md-12 p-0 m-0">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="name"
                            type="text"
                            label={firstname}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <Field
                            name="email"
                            type="email"
                            label={emailaddress}
                            placeholder=""
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="md-form mb-0">
                          <Field
                            name="phone"
                            type="tel"
                            label={phoneno}
                            placeholder="(+ 33 (0)6 XX XX XX)"
                            className="form-control"
                            component={this.renderInput}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="md-form">
                          <Field
                            name="message"
                            type="textarea"
                            label={yourmessage}
                            placeholder=""
                            className="form-control md-textarea"
                            rows="2"
                            component={this.renderTextarea}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 col-md-12 mt-6 d-flex flex-column p-0 m-0 text-center" >
                    <ul className="list-unstyled mb-0">
                      {/* <li>
                        <i className="fa fa-map-marker"></i>
                        <p>4 rue des Fosses Saint-Jacques 75005 PARIS</p>
                      </li>
                      <li>
                        <i className="fa fa-phone"></i>
                        <p>+ 33 (0) 9 83 20 00 15</p>
                      </li> */}
                      <li>
                        <i className="fa fa-envelope"></i>
                        <p>contact@pilotrh.com</p>
                      </li>
                    </ul>
                  </div>

                  {/* ✅ CAPTCHA added here (above submit) */}
                  <div className="col-md-12 text-center" style={{ marginTop: 10 }}>
                    <ReCAPTCHA
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={this.onCaptchaChange}
                      onExpired={this.onCaptchaExpired}
                    />
                    {this.state.recaptchaError ? (
                      <small className="text-danger d-block mt-2">
                        {this.state.recaptchaError}
                      </small>
                    ) : null}
                  </div>

                  <div className="col-md-12 text-center">
                    <div
                      className="spinner-border text-primary m-auto"
                      role="status"
                      id="contactus-loader"
                    >
                      <span className="sr-only">
                        <FormattedMessage id="loading" defaultMessage="Loading..." />
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12 text-center">
                    <input type="hidden" name="language" value={this.props.lang} />
                    <button
                      type="submit"
                      name="send-query"
                      id="send-query"
                      tabIndex="4"
                      className="btn btn-primary"
                      ref="sbmt"
                      disabled={!this.state.recaptchaToken}
                    >
                      <FormattedMessage id="submit" defaultMessage="SUBMIT" />
                    </button>
                  </div>

                  <div className="status"></div>
                </form>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-12 p-4 m-0 text-center">
                  {this.errorMessage()}
                  <div className="col-sm-12 mx-auto text-center mb-4 pb-45">
                    <Link to={redirectUrl} className="btn btn-warning mt-3 mx-3">
                      <FormattedMessage
                        id="do_another_test"
                        defaultMessage="DO ANOTHER TEST"
                      />
                    </Link>
                    <Link to="/" className="btn btn-primary mt-3 mx-3">
                      <FormattedMessage
                        id="back_to_home"
                        defaultMessage="BACK TO HOME PAGE"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </React.Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.name) errors.name = "Name is required";
  if (!values.email) errors.email = "Email address is required";
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.username = "Invalid email";
  }
  if (!values.message) errors.message = "Message is required";
  return errors;
};

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    contactUsValidation: state.form.contactUsValidation,
    contactCoachError: state.auth.contactCoachError,
    contactCoachMessage: state.auth.contactCoachMessage,
    lang: state.locale.lang,
  };
};

ContactToCoach = connect(mapStateToProps, { contactacoach, clearContactCoachMessage })(
  ContactToCoach
);

export default reduxForm({
  form: "contactUsValidation",
  enableReinitialize: true,
  validate,
})(ContactToCoach);
